document.addEventListener('DOMContentLoaded',()=>{const root=document.getElementById('bg-global-header');if(!root)return;const toggle=root.querySelector('.menu-toggle'),links=root.querySelector('.navlinks');toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');links.classList.toggle('open',open)});links.addEventListener('click',e=>{if(e.target.closest('a')){links.classList.remove('open');toggle.setAttribute('aria-expanded','false')}})});
document.addEventListener('DOMContentLoaded',()=>{
 const header=document.getElementById('bg-global-header');
 if(!header)return;
 const mobile=matchMedia('(max-width:760px)');
 const toggle=header.querySelector('.menu-toggle');
 let last=Math.max(0,scrollY),distance=0,direction=0,pending=false;
 const show=()=>header.classList.remove('bg-nav-hidden');
 function update(){
  pending=false;
  const y=Math.max(0,Math.min(scrollY,document.documentElement.scrollHeight-innerHeight));
  const delta=y-last;last=y;
  if(!mobile.matches||y<110||toggle.getAttribute('aria-expanded')==='true'||header.contains(document.activeElement)){show();distance=0;return;}
  const next=Math.sign(delta);
  if(next!==direction){distance=0;direction=next;}
  distance+=delta;
  if(distance>18){header.classList.add('bg-nav-hidden');distance=0;}
  else if(distance< -6){show();distance=0;}
 }
 addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});
 mobile.addEventListener('change',()=>{show();last=Math.max(0,scrollY);distance=0;});
 header.addEventListener('focusin',show);
 toggle.addEventListener('click',show);
 addEventListener('hashchange',()=>{show();distance=0;last=Math.max(0,scrollY);});
});
